(function() {
  "use strict";
  angular.module("marketPlace.niches", []);
})();
